export default __webpack_public_path__ + "static/media/honeymoon4.8f7fe382.webp";